import { convertStyleData, transformPx2Rem } from '@utils/tools';

import './FormButtonCustomComponent.less';

export default function FormButtonCustomComponent(props) {
  /**
   * 传入数据
   */ 
  // 组件数据
  const data = props.data;                
  // 组件配置对象
  const customFeature = data.customFeature;
  // 动态数据
  const dynamicData = props.dynamicData;
  // 组件状态
  const canUse = data.can_use || 1;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  if (canUse != 1) {
    styleObj['backgroundImage'] = customFeature.lineBackgroundImage;
    styleObj['backgroundColor'] = customFeature.lineBackgroundColor;
  }
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = customFeature.segment; // 已绑定字段
  if (dynamicData && segment) {               // 当前组件有动态数据并已绑定某字段
    content = dynamicData[segment]; // TODO: 如果content为富文本，需要处理
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component form-button" style={styleObj} disabled={canUse != 1} onClick={props.onSubmit}>
      {canUse == 1 ? data.content : customFeature.disabledContent || '已提交' }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/form-button-custom-component/FormButtonCustomComponent.jsx